<!-- Header -->
<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles modal-header-titles--barra">
    <h2 class="modal-title">Nova oportunidade</h2>
    <span class="modal-subtitle">O card entrará na etapa escolhida e seguirá o fluxo do Kanban</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" [disabled]="salvando"
      (click)="fechar()" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">

  @if (data.textoOrigem) {
    <app-alert-card type="info" class="nod-aviso-origem">{{ data.textoOrigem }}</app-alert-card>
  }

  <!-- IDENTIFICAÇÃO -->
  <div class="section-container">
    <div class="section-title">
      <mat-icon class="material-symbols-outlined">badge</mat-icon>
      <span>Identificação</span>
    </div>

    <div class="row g-3">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Assunto</mat-label>
          <input matInput [(ngModel)]="titulo" maxlength="120" required
            placeholder="Ex.: Renovação de contrato anual" />
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          [control]="clienteControl"
          [apiUrl]="urlPessoa"
          [extraParams]="filtroCliente"
          [preloadedOptions]="clientesIniciais"
          [idField]="'id'"
          [nameField]="'descricao'"
          [label]="'Cliente'"
          [hint]="hintCliente"
          [disabled]="salvando"
          (selectionChange)="onClienteSelecionado($event)"
          subscriptSizing="dynamic">
        </app-select-pesquisavel>
      </div>

      @if (!contatoNovoAberto) {
        <div class="col-12 col-md-6">
          <app-select-pesquisavel
            [control]="contatoControl"
            [offlineList]="contatos"
            [preloadedOptions]="contatos"
            [idField]="'id'"
            [nameField]="'descricao'"
            [label]="'Contato'"
            [isOptional]="true"
            [showAddNew]="podeCriarContato"
            addNewLabel="+ Novo contato"
            [disabled]="!clienteControl.value || carregandoContatos || salvando"
            [hint]="semContatos ? 'Este cliente não tem contatos cadastrados.' : ''"
            (addNew)="abrirContatoNovo()"
            subscriptSizing="dynamic">
          </app-select-pesquisavel>
        </div>
      } @else {
        <!-- Contato fora da lista, na mesma linha: vai para o cadastro do cliente ao criar a oportunidade. -->
        <div class="col-12" [formGroup]="contatoNovoForm">
          <div class="nod-contato-novo">
            <mat-form-field appearance="outline" class="nod-contato-novo__nome" subscriptSizing="dynamic">
              <mat-label>Nome do novo contato</mat-label>
              <input matInput formControlName="nome" maxlength="120" required />
              <mat-error>Informe o nome.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="nod-contato-novo__campo" subscriptSizing="dynamic">
              <mat-label>Telefone</mat-label>
              <input matInput formControlName="telefone" type="tel" placeholder="(00) 0000-0000"
                [mask]="masks.phone" required />
              <mat-error>{{ contatoNovoForm.controls.telefone.hasError('required') ? 'Informe o telefone.' : 'Informe o telefone completo.' }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="nod-contato-novo__campo" subscriptSizing="dynamic">
              <mat-label>E-mail</mat-label>
              <input matInput formControlName="email" type="email" maxlength="120" required />
              <mat-error>{{ contatoNovoForm.controls.email.hasError('required') ? 'Informe o e-mail.' : 'Informe um e-mail válido.' }}</mat-error>
            </mat-form-field>

            <!-- O span carrega o tooltip: botão desabilitado não dispara eventos de mouse. -->
            <span matTooltip="Escolher um contato da lista">
              <button mat-icon-button type="button" class="nod-contato-novo__voltar" [disabled]="salvando"
                aria-label="Escolher um contato da lista" (click)="cancelarContatoNovo()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
              </button>
            </span>
          </div>
          <p class="nod-contato-novo__info">O contato é salvo no cadastro do cliente ao criar a oportunidade.</p>
        </div>
      }

      @if (clienteComOportunidadeEmAndamento) {
        <div class="col-12">
          <app-alert-card type="warning">Este cliente já tem oportunidade em andamento no CRM.</app-alert-card>
        </div>
      }
    </div>
  </div>

  <!-- CLASSIFICAÇÃO -->
  <div class="section-container">
    <div class="section-title">
      <mat-icon class="material-symbols-outlined">tune</mat-icon>
      <span>Classificação</span>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Origem do lead</mat-label>
          <mat-select [(ngModel)]="idOrigemLead" required>
            @for (origem of data.origens; track origem.id) {
              <mat-option [value]="origem.id">{{ origem.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Canal de contato</mat-label>
          <mat-select [(ngModel)]="idCanalContato">
            <mat-option [value]="null">Não informado</mat-option>
            @for (canal of data.canais; track canal.id) {
              <mat-option [value]="canal.id">{{ canal.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Etapa inicial</mat-label>
          <mat-select [(ngModel)]="idEtapaKanban">
            @for (etapa of etapasDisponiveis; track etapa.idEtapaKanban) {
              <mat-option [value]="etapa.idEtapaKanban">{{ etapa.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Prioridade</mat-label>
          <mat-select [(ngModel)]="prioridade">
            <mat-select-trigger>
              <span class="nod-prio-dot" [style.background]="corDaPrioridade(prioridade)"></span>
              {{ rotuloDaPrioridade(prioridade) }}
            </mat-select-trigger>
            @for (p of prioridades; track p.chave) {
              <mat-option [value]="p.chave">
                <span class="nod-prio-dot" [style.background]="p.cor"></span>
                {{ p.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- NEGOCIAÇÃO -->
  <div class="section-container">
    <div class="section-title">
      <mat-icon class="material-symbols-outlined">payments</mat-icon>
      <span>Negociação</span>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6">
        <app-select-pesquisavel
          [control]="vendedorControl"
          [offlineList]="opcoesVendedor"
          [preloadedOptions]="opcoesVendedor"
          [idField]="'idVendedor'"
          [nameField]="'nome'"
          [label]="'Vendedor responsável'"
          [hint]="hintVendedor"
          (selectionChange)="onVendedorSelecionado()"
          subscriptSizing="dynamic">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Valor estimado</mat-label>
          <input matInput currencyMask [(ngModel)]="valorEstimado"
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- TAGS -->
  @if (data.tags.length) {
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">label</mat-icon>
        <span>Tags</span>
        @if (tagsControl.value.length) {
          <span class="status-badge badge-cinza">{{ tagsControl.value.length }}</span>
        }
      </div>

      <!-- Mesmo seletor das tags do documento de venda: dropdown múltiplo e as escolhidas como selos. -->
      <app-select-pesquisavel
        label="Tags"
        [control]="tagsControl"
        [offlineList]="data.tags"
        idField="idTagCrm"
        nameField="descricao"
        corField="cor"
        [multiple]="true"
        [showBadges]="true"
        placeholder="Selecione...">
      </app-select-pesquisavel>
    </div>
  }

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="salvando"
    (click)="fechar()">Cancelar</button>
  <span [matTooltip]="motivoBloqueio" [matTooltipDisabled]="!motivoBloqueio || salvando">
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="salvando"
      [disabled]="!valido || salvando" [attr.aria-label]="salvando ? 'Criando oportunidade' : 'Criar oportunidade'"
      (click)="criar()">
      Criar oportunidade
      @if (salvando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </span>
</mat-dialog-actions>
